import api from '../../../utils/api';
import config from '../../../config.json';

const BASE = (process.env.REACT_APP_API_BASE || `${config.service}/api`).replace(/\/$/, '');

/**
 * Получение логов аудита Reconciliation Job
 * @param {Object} params
 * @param {number} params.limit - количество записей (по умолчанию 100, максимум 500)
 * @param {string} params.type - фильтр по типу: missing, amount_mismatch, reversed
 * @returns {Promise<{count: number, logs: Array}>}
 */
export async function fetchAuditLog({ limit = 100, type = null } = {}) {
    try {
        const params = new URLSearchParams();

        // Ограничиваем лимит
        const safeLimit = Math.min(Math.max(1, limit), 500);
        params.append('limit', safeLimit);

        // Добавляем фильтр типа, если указан
        if (type && ['missing', 'amount_mismatch', 'reversed'].includes(type)) {
            params.append('type', type);
        }

        const url = `${BASE}/kepler-rob/audit-log?${params.toString()}`;
        const { data } = await api.get(url);

        return {
            count: data?.count || 0,
            logs: Array.isArray(data?.logs) ? data.logs : [],
        };
    } catch (error) {
        console.error('Ошибка при загрузке audit log:', error);

        // Прокидываем ошибку с понятным сообщением
        const message = error?.response?.data?.message
            || error?.response?.data?.error
            || error?.message
            || 'Неизвестная ошибка при загрузке данных';

        throw new Error(message);
    }
}
